import axios from '@fs/zion-axios'

const BASE_TEMPLE_PATH = '/service/dmc/temple'
const BASE_TEMPLE_INVENTORY_PATH = '/service/dmc/temple-inventory'

export function getTemplesFromDirectory() {
  const url = `${BASE_TEMPLE_INVENTORY_PATH}/temples`
  const config = null

  return axios.get(url, config).then((response) => {
    return response.data
  })
}

export function getCtrsByOdmId(type, id) {
  const url = `${BASE_TEMPLE_PATH}/certified-temple-records/${type}/${id}`
  const config = null

  return axios.get(url, config).then((response) => {
    return response.data
  })
}

export function getRequest(id) {
  return axios.get(`${BASE_TEMPLE_PATH}/family-ordinance-requests/${id}`)
}

export async function getPrintableInventoryName(id) {
  return axios.get(`${BASE_TEMPLE_PATH}/printable-inventory-names/${id}`)
}

export function createCtrs(createCtrRequest) {
  return axios.post(`${BASE_TEMPLE_PATH}/certified-temple-records`, createCtrRequest)
}
